import { useRef, useState } from "react";
import classes from "./Checkout.module.css";
//using helper functions obver here

const isEmpty = (value) => value.trim() === "";
const isFiveChars = (value) => value.trim().length === 11;

const Checkout = (props) => {
  const [formInputValidity, setFormInputValidity] = useState({
    name: true,
    street: true,
    city: true,
    number: true,
  });
  const nameInputRef = useRef();
  const streetInputRef = useRef();
  const numberInputRef = useRef();
  const cityInputRef = useRef();

  const confirmHandler = (event) => {
    event.preventDefault();

    const enteredName = nameInputRef.current.value;
    const enteredStreet = streetInputRef.current.value;
    const enteredNumber = numberInputRef.current.value;
    const enteredCity = cityInputRef.current.value;

    const enteredNameIsValid = !isEmpty(enteredName);
    const enteredStreetIsValid = !isEmpty(enteredStreet);
    const enteredCityIsValid = !isEmpty(enteredCity);
    const enteredNumberIsValid = isFiveChars(enteredNumber);

    // assigning new values to all the keys
    //with this we have information of the validdity of the different keys
    setFormInputValidity({
      name: enteredNameIsValid,
      street: enteredStreetIsValid,
      city: enteredCityIsValid,
      number: enteredNumberIsValid,
    });
    const formIsValid =
      enteredNameIsValid &&
      enteredStreetIsValid &&
      enteredCityIsValid &&
      enteredNumberIsValid;

    if (!formIsValid) {
      return;
    }
    //we can now submit the cart data

    props.onConfirm(
      {
        name: enteredName,
        street: enteredStreet,
        city: enteredCity,
        number: enteredNumber,
      },
      event
    );
  };

  const nameControlClasses = `${classes.control} ${
    formInputValidity.name ? "" : classes.invalid
  }`;
  const streetControlClasses = `${classes.control} ${
    formInputValidity.street ? "" : classes.invalid
  }`;
  const numberControlClasses = `${classes.control} ${
    formInputValidity.number ? "" : classes.invalid
  }`;
  const cityControlClasses = `${classes.control} ${
    formInputValidity.city ? "" : classes.invalid
  }`;

  //submitting the data back to the cart
  return (
    <form className={classes.form} onSubmit={confirmHandler}>
      <div className={nameControlClasses}>
        <label htmlFor="name">Your Name</label>
        <input ref={nameInputRef} type="text" id="name" />
        {!formInputValidity.name && <p>Please enter a valid name</p>}
      </div>
      <div className={streetControlClasses}>
        <label htmlFor="street">Street Address</label>
        <input ref={streetInputRef} type="text" id="street" />
        {!formInputValidity.street && <p>Please enter a valid street</p>}
      </div>
      <div className={numberControlClasses}>
        <label htmlFor="number">Phone number</label>
        <input ref={numberInputRef} type="number" id="number" />
        {!formInputValidity.number && (
          <p>Please enter a valid 11 digits number(0814237XXXX)</p>
        )}
      </div>
      <div className={cityControlClasses}>
        <label htmlFor="city">City</label>
        <input ref={cityInputRef} type="text" id="city" />
        {!formInputValidity.city && <p>Please enter a valid city</p>}
      </div>
      <div className={classes.actions}>
        <button
          type="button"
          onClick={props.onCancel}
          disabled={props.isSubmitting}
          className={classes.ghost}
        >
          Cancel
        </button>
        <button
          className={classes.submit}
          disabled={props.isSubmitting}
          type="submit"
        >
          {props.isSubmitting ? "Placing order…" : "Place Order"}
        </button>
      </div>
    </form>
  );
};

export default Checkout;
